import {
  ADD_ROLE_FAILURE,
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  DELETE_ROLE_FAILURE,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  FETCH_ALL_LIST_ROLE_FAILURE,
  FETCH_ALL_LIST_ROLE_REQUEST,
  FETCH_ALL_LIST_ROLE_SUCCESS,
  FETCH_LIST_ROLE_FAILURE,
  FETCH_LIST_ROLE_REQUEST,
  FETCH_LIST_ROLE_SUCCESS,
  FETCH_ROLE_FAILURE,
  FETCH_ROLE_REQUEST,
  FETCH_ROLE_SUCCESS,
  RESET_CURRENT_ROLE, UPDATE_ROLE_FAILURE,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS
} from "./roleType";

export const fetchRoles = (pageNo) => ({
  type: FETCH_LIST_ROLE_REQUEST,
  payload: pageNo ,
});

export const fetchRolesSuccess = (roles) => ({
  type: FETCH_LIST_ROLE_SUCCESS,
  payload: { roles },
});

export const fetchRolesFailure = (error) => ({
  type: FETCH_LIST_ROLE_FAILURE,
  payload: { error },
});

export const fetchAllRoles = () => ({
  type: FETCH_ALL_LIST_ROLE_REQUEST,
});

export const fetchAllRolesSuccess = (roles) => ({
  type: FETCH_ALL_LIST_ROLE_SUCCESS,
  payload: { roles },
});

export const fetchAllRolesFailure = (error) => ({
  type: FETCH_ALL_LIST_ROLE_FAILURE,
  payload: { error },
});

// View single role
export const fetchRole = (roleId) => ({
  type: FETCH_ROLE_REQUEST,
  payload: { roleId },
});

export const fetchRoleSuccess = (roles) => ({
  type: FETCH_ROLE_SUCCESS,
  payload: { roles },
});

export const fetchRoleFailure = (error) => ({
  type: FETCH_ROLE_FAILURE,
  payload: { error },
});

// Add role
export const addRole = (roleData) => ({
  type: ADD_ROLE_REQUEST,
  payload: { roleData },
});

export const addRoleSuccess = (role) => ({
  type: ADD_ROLE_SUCCESS,
  payload: { role },
});

export const addRoleFailure = (error) => ({
  type: ADD_ROLE_FAILURE,
  payload: { error },
});

// Edit role
export const updateRole = (roleId, roleData) => {
  return {
    type: UPDATE_ROLE_REQUEST,
    payload: { roleId, roleData },
  };
};

export const updateRoleSuccess = (role) => ({
  type: UPDATE_ROLE_SUCCESS,
  payload: { role },
});

export const updateRoleFailure = (error) => ({
  type: UPDATE_ROLE_FAILURE,
  payload: { error },
});

// Delete role
export const deleteRole = (roleId) => {
  return {
    type: DELETE_ROLE_REQUEST,
    payload: { roleId },
  };
};
export const deleteRoleSuccess = (roleId) => ({
  type: DELETE_ROLE_SUCCESS,
  payload: { roleId },
});

export const deleteRoleFailure = (error) => ({
  type: DELETE_ROLE_FAILURE,
  payload: { error },
});

// Reset current role
export const resetCurrentRole = () => ({
  type: RESET_CURRENT_ROLE,
});